import * as yup from "yup"
import {
  getFieldMessages,
  fullNameField,
  phoneField,
  optionalEmailField,
  optionalTextField,
  checkboxField,
  type FormLanguage,
} from "../../common/forms"

const messageMax = {
  he: "ניתן להקליד עד 300 תווים",
  en: "You can type up to 300 characters",
}

export function createSchema(language: FormLanguage, checkboxRequired: boolean) {
  const m = getFieldMessages(language)

  return yup.object({
    fullName: fullNameField(m),
    phone: phoneField(m),
    email: optionalEmailField(m),
    company: optionalTextField(),
    message: yup
      .string()
      .max(300, language === "en" ? messageMax.en : messageMax.he)
      .optional()
      .default(""),
    checkbox: checkboxField(m, checkboxRequired),
  })
}

export type FormValues = yup.InferType<ReturnType<typeof createSchema>>

export const defaultValues: FormValues = {
  fullName: "",
  phone: "",
  email: "",
  company: "",
  message: "",
  checkbox: false,
}
